import * as cheerio from 'cheerio'

import { useEffect, useState } from 'react'

import { Button } from '@lockerpm/design'
import CardBlog from '@/components/pages/blog/CardBlog'
import blogServices from '@/services/blog'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

export default function ReleatedPost({ post, categories }) {
  const [posts, setPosts] = useState([])
  const { t } = useTranslation('blog')
  const router = useRouter()
  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    try {
      const languageTags = await blogServices.fetchBlogTag({ slug: router.locale })
      const currentTagId = languageTags.data[0].id
      const paramsFetchPost = {
        _embed: 1,
        page: 1,
        per_page: 3,
        tags: currentTagId,
        categories: categories.map((item) => item.id.toString()).join(','),
      }
      const response = await blogServices.fetchBlogPost(paramsFetchPost)
      const responseUsers = await blogServices.fetchBlogUser({
        page: 1,
        per_page: 20,
      })
      const posts = []
      response.data.forEach(async (post) => {
        let featuredImage = ''
        try {
          featuredImage = post._embedded['wp:featuredmedia']['0'].source_url
        } catch (error) {}
        if (!featuredImage) {
          const $ = cheerio.load(post.content.rendered)
          const images = $('img').attr('src')
          if (images) {
            featuredImage = images.replace(/-[0-9]+x[0-9]+/g, '')
          }
        }
        const $_ = cheerio.load(post.excerpt.rendered)
        const desc = $_('p').text()
        posts.push({
          ...post,
          featured_image: featuredImage,
          user: responseUsers.data.find((author) => author.id === post.author),
          desc,
        })
      })
      setPosts(posts)
    } catch (error) {
      console.log('error: ' + error)
    }
  }
  return (
    <section className="section-container py-12 lg:py-24 border border-solid border-l-0 border-r-0 border-b-0 border-[#E4E7EC]">
      <p className="text-center font-semibold text-[#1B5D25] text-md mb-3">{t('latest_news')}</p>
      <h2 className="text-display-md font-semibold text-[#101828] mb-5 text-center">
        {t('releated_post.title')}
      </h2>
      <p className="text-xl text-[#475467] text-center">{t('releated_post.description')}</p>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 mt-16">
        {posts.length
          ? posts.map((item) => (
              <div className="col-span-1" key={item.id}>
                <CardBlog blog={item} />
              </div>
            ))
          : null}
      </div>
      <div className="flex justify-center mt-16">
        <Link href={'/blog'}>
          <Button className="rounded-lg font-semibold h-12" type="primary" size="large">
            {t('view_all_posts')}{' '}
          </Button>
        </Link>
      </div>
    </section>
  )
}
